import { Mail, MessageCircle } from "lucide-react";
import { BRAND } from "@/data/content";
import { useLanguage } from "@/i18n/LanguageContext";

const NAV_IDS = ["home", "sobre", "servicos", "projetos", "case", "contatos"];

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer data-testid="site-footer" className="border-t border-emerald-500/10 bg-[#050D09] py-14">
      <div className="mx-auto grid max-w-7xl gap-12 px-6 sm:px-10 md:grid-cols-3 lg:px-16">
        <div>
          <a href="#home" data-testid="footer-logo-link" className="flex flex-col items-center leading-none">
            <img src="/logo.png" alt="Eco Build Group Solution" className="h-24 w-auto" />
            <span className="mt-2 flex w-24 justify-between font-mono-tech text-[10px] font-bold uppercase text-emerald-400">
              {t.wordmark.split("").map((letter, i) => (
                <span key={i}>{letter}</span>
              ))}
            </span>
          </a>
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-slate-400">
            {t.footer.tagline}
          </p>
        </div>

        <div>
          <p className="font-mono-tech text-xs uppercase tracking-[0.3em] text-emerald-400">
            {t.footer.navTitle}
          </p>
          <nav className="mt-5 flex flex-col gap-3">
            {NAV_IDS.map((id) => (
              <a
                key={id}
                href={`#${id}`}
                data-testid={`footer-nav-${id}-link`}
                className="w-fit text-sm text-slate-300 transition-colors duration-300 hover:text-emerald-400"
              >
                {t.nav[id]}
              </a>
            ))}
          </nav>
        </div>

        <div>
          <p className="font-mono-tech text-xs uppercase tracking-[0.3em] text-emerald-400">
            {t.footer.contactTitle}
          </p>
          <div className="mt-5 flex flex-col gap-3">
            <a
              href={`mailto:${BRAND.email}`}
              data-testid="footer-email-link"
              className="flex w-fit items-center gap-2.5 text-sm text-slate-300 transition-colors duration-300 hover:text-emerald-400"
            >
              <Mail className="h-4 w-4 shrink-0 text-emerald-500" />
              {BRAND.email}
            </a>
            <a
              href={BRAND.whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp-link"
              className="flex w-fit items-center gap-2.5 text-sm text-slate-300 transition-colors duration-300 hover:text-emerald-400"
            >
              <MessageCircle className="h-4 w-4 shrink-0 text-emerald-500" />
              {BRAND.whatsappDisplay}
            </a>
          </div>
        </div>
      </div>

      <div className="mx-auto mt-12 flex max-w-7xl flex-col gap-2 border-t border-emerald-500/10 px-6 pt-8 sm:px-10 lg:px-16">
        <p className="text-xs text-slate-500">
          © 2026 {BRAND.name}. {t.footer.rights}
        </p>
        <p className="text-xs text-slate-600">{t.footer.disclaimer}</p>
      </div>
    </footer>
  );
};

export default Footer;
